<template>
<div>
  <div :style="($ml.current === 'EN') ? 'display:block;' : 'display:none;'" >
    <vue-markdown style="overflow: auto;" @rendered="onrendered">
## Identify the videos with Video ID

A custom videoID can be inserted inside of the Quanteec configuration, next to your quanteecKey :
```
var configQuanteec = {
    quanteecKey: "your-quanteec-key",
    videoID: "custom-video-id"
  };
```

The videoID are used by Quanteec to identify the video. Hence, two players are able to know they are watching the same content and they can exchange data. If the videoID is different, the players will not be able to connect. If no videoID is specified in the configuration, the url of the video source is used as a videoID. 

If the video url are the same for every viewer for one video, then it is enough and videoID are not needed. However, if the urls are generated for every viewers (it may be the case if a token is used in the path of the url for security reasons) then the players will think they are not watching the same content, preventing the Quanteec plugin to be efficient. In this situation, videoID are needed.


## Use Quanteec with Server Side Ad Insertion (SSAI)

SSAI is used to insert ads on server side. The ads may be targetted and may be different from one viewer to another. By default, the Quanteec Plugin uses segments metadata to identify the segments to send from one viewer to another. However, if the users are not watching the same add, they should not exchange video data.

To manage SSAI, it is possible to set “checkUrls” to true in the Quanteec configuration. With this parameter, the exact url of the segments will be checked too before sending the segments. Hence, two viewers will be able to share the main video, but not the ads if they are behind different url addresses.

In some situations, checking the url may be an issue if the urls are different from every viewer. As an example, the url may include a token identifying the viewer. When needed, “ignoreTokenInUrls” can be used with “checkUrls” in order to define a token or a pattern (in javascript regex format) to ignore when comparing two urls. In order to validate a “ignoreTokenInUrls”, it is possible to add the configuration “logLevel: 2” and see the saved url in the console of the web browser.


      </vue-markdown>
  </div>
  <div :style="($ml.current === 'FR') ? 'display:block;' : 'display:none;'">
    <vue-markdown style="overflow: auto;" @rendered="onrendered">
## Identifier les vidéos avec un videoID

Un videoID spécifique peut être inséré dans la configuration de Quanteec, à côté de votre quanteecKey.
```
var configQuanteec = {
    quanteecKey: "your-quanteec-key",
    videoID: "custom-video-id"
  };
```

Les videoId sont utilisés par Quanteec pour identifier les vidéos. Ainsi, 2 lecteurs de vidéo savent qu'ils affichent le même contenu et peuvent échanger des données. Si les videoID sont différents, les lecteurs ne seront pas capable de se connecter. Si aucun videoID n'est utilisé, l'url de la source de la vidéo est utilisée.

Si les urls sont les mêmes popur chaque utilisateur, les videoID ne sont pas nécessaires. Cependant, si les urls sont différentes pour chaque utilisateur (par exemple si un token est utilisé dans l'url pour des raisons de sécurité) alors les lecteurs penseront qu'ils n'affichent pas la même vidéo, diminuant l'efficacité de Quanteec. Dans cette situation, utiliser un videoID est nécessaire.


## Utiliser Quanteec avec le Server Side Ad Insertion (SSAI)

Les SSAI est utilisé pour insérer des publicités côté serveur. Les pubs peuvent être ciblées et être différentes d'un utilisateur à l'autre. Par défaut, le plugin Quanteec utilise des métadonnées des segments pour identifier les segments à envoyer d'un utilisateur à l'autre. Cependant, si les utilisateurs ne regardent pas la même publicité, ils ne devraient pas s'échanger de données.

Pour gérer le SSAI, il est possible d'utiliser le paramètre "checkUrls" dans la configuration de Quanteec. Avec ce paramètre, l'url exacte des segments va être vérifiée avant d'envoyer ou recevoir les segments en P2P. Ainsi, deux spectateurs pourront s'échanger l'émission principale, mais pas les publicités si elles se trouvent à des adresses différentes.

Dans certaines situations, vérifier l'url peut être problématique si les urls sont différentes pour chaque utilisateur. Par exemple, les urls peuvent contenir un token pour identifier chaque utilisateur. Quand c'est nécessaire, "ignoreTokenInUrls" peut être utilisé avec "checkUrls" pour définir un token ou un pattern (au format regex de javascript) à ignorer au moment de la comparaison des url. Pour valider un "ignoreTokenInUrls", il est possible d'ajouter un "logLevel: 2" dans la configuration de Quanteec pour afficher l'url sauvegardée dans la console du navigateur.

    </vue-markdown>
  </div>
</div>
</template>
<script>
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'OtherDoc',
  data: function() {
    return {
     
    }
  },
  components: {
      VueMarkdown
  },
  mounted: function() {
 
  },
  methods: {
     onrendered() {
        Prism.highlightAll()
     }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>